import { ApartmentOutlined } from '@mui/icons-material';
import { Box, Button, Card, styled, Typography } from '@mui/material';
import Dropzone, {
  DropzoneHandle,
} from 'further-ui/components/FileDrop/Dropzone';
import { Column, Row } from 'further-ui/components/Layout';
import { useRef } from 'react';

const PaddedCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(theme.spacingSizes.sm),
}));

const FixedWidthColumn = styled(Column)(() => ({
  width: '100px',
}));

const LogoPreview = styled(Box)<{ src: string }>(({ src, theme }) => ({
  minWidth: '126px',
  alignSelf: 'stretch',
  borderRadius: '8px',
  backgroundImage: `url(${src})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  border: `1px solid ${theme.palette.grey[300]}`,
}));

type FileData = { fileData: File; fileName: string; previewUri: string };

type Props = {
  onChange: (value: Array<FileData> | null) => void;
  fileUrl?: string;
};

const LogoUpload: React.FC<Props> = ({ onChange, fileUrl }: Props) => {
  const dropzoneRef = useRef<DropzoneHandle>(null);

  const handleChange = (data?: Array<FileData>) => {
    if (fileUrl) {
      onChange(null);
    } else if (data) onChange(data);
  };

  return (
    <PaddedCard variant="outlined">
      <Row spacing="lg">
        {fileUrl ? (
          <LogoPreview src={fileUrl} />
        ) : (
          <Dropzone
            ref={dropzoneRef}
            onDropFile={(data) => handleChange(data)}
            maxFiles={1}
            content={
              <FixedWidthColumn fullWidth fullHeight justify="center" centered>
                <ApartmentOutlined fontSize="medium" />
              </FixedWidthColumn>
            }
          />
        )}
        <Column spacing="xs">
          <Typography variant="h6">Logo</Typography>
          <Column spacing="md">
            <Typography variant="body2">
              This square company logo is used across your system and portal.
            </Typography>
            <Box>
              <Button
                onClick={() =>
                  fileUrl ? handleChange() : dropzoneRef.current?.open()
                }
                size="large"
                variant="contained"
              >
                {fileUrl ? 'Remove' : 'Upload'}
              </Button>
            </Box>
          </Column>
        </Column>
      </Row>
    </PaddedCard>
  );
};

export default LogoUpload;
